// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mdlj","fullView":"styles_fullView__3GvyV"};